<template>

  <vs-row
  vs-align="center"
  vs-type="flex" vs-justify="center" vs-w="12">
  <!-- {{bool}} -->
    <select v-model="bool"
    @change="update(params)"
      class="w-100 selectExample mt-2 customSelect">
     <option :key="index"
       :value="item.id" 
       :label="item.country_name"
        v-for="(item,index) 
        in countryList"
       class="selectOptionclass"/>
    </select>
  </vs-row>
</template>
<script>
import vSelect from 'vue-select'
export default {
  components:{
    vSelect
  },
  data () {
    return {
      bool: null,
      countryList:[],
      addDetailsModal:false
      
    }
  },
  /*  created () {
  }, */
  created () {
    this.countryList = this.params.colDef.filterParams.country
    this.bool = this.params.data.basic_details.address != null ? this.params.data.basic_details.address.platform_customer_countries_id : ''
   
  },

  methods: {
    async update (data1) {
      const data = []
      data.colId = 'platform_customer_countries_id'
      data.user_id = this.params.data.basic_details.operation_user_id
      data.fieldvalue = this.bool
      if (this.bool && this.params.data.basic_details.active_user === 1) {
        this.params.colDef.filterParams.update_user(data)
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t edit non actionable row",
          ...this.warnProp(),
        });
        return false
      }
          
    }
  }
}
</script>
<style scoped>
  .customSelect {
    border-radius:3px;
    border: 1px solid #CCCCCC;
    width: 100%;
    height:30px;
    background-color: white;
    color:#757575
    /* font-family: $font-family-base'; */
  }
  .selectOptionclass :hover
  {
    background-color:yellow;
    color:white;
    border:none;
  }

</style>
